export default class Sponsors {

	constructor() {
        this.objectUrlMap = {};
    }

    static init() {
        const self = new Sponsors();
        self.attachEvents();
    }

    attachEvents() {
        $(document).on("click", ".js-sponsor-check", function (e) {
            var positionId = $(this).data('position-id');
            var sponsorCheck = $("#sponsor-" + positionId + "-enable");

            if (sponsorCheck.is(":checked")) {
                $(".sponsor-" + positionId + "-tabs").slideUp(250);
            } else {
                $(".sponsor-" + positionId + "-tabs").slideDown(250);
            }

            // if no sponsor is selected and no file is uploaded, click first one
            let selectedSponsorId = $('#selected_sponsor_' + positionId).val();
            let fileName = $('#sponsor-' + positionId + '-filename').val();
            if (!selectedSponsorId && !fileName) {
                $(".sponsor-body[data-position-id='" + positionId + "'] .sponsor-image").first().trigger('click');
            }
        });

		$(document).on('click', '.js-sponsor-image', function (e) {
			e.preventDefault();
			let $el = $(this);
			let positionId = $el.data('position-id');
			let sponsorId = $el.data('sponsor-id');
			let sponsorName = $el.data('sponsor-name') || '';
			$('#selected_sponsor_' + positionId).val(sponsorId);
			$el.siblings(".sponsor-image").removeClass("active");
			if ($el.hasClass("active")){
				$el.removeClass("active");
				$('#sponsor_name_' + positionId).text(sponsorName);
				$('.sponsor-image-filename').addClass('d-none');
			} else {
				$el.addClass("active");
				$('#sponsor_name_' + positionId).text(sponsorName);
				$('.sponsor-image-filename').removeClass('d-none');
			}
		});

		$(document).on('click', '.js-tab-sponsor-link', function (e) {
            e.preventDefault();
            let $link = $(this);
            let target = $link.attr('href');
            let $tabs = $link.closest('.tabs');

            $tabs.find('.tabs-list li').removeClass('is-active');
            $tabs.find('.tabs-pane').removeClass('is-active');

            $link.parent().addClass('is-active');
            $(target).addClass('is-active');

			if (target && target.endsWith('upload')) {
				$(".sponsor-body").find(".sponsor-image").removeClass("active")
				$(".sponsor-image-filename").addClass("d-none");
			} else {
			}
        });

        $(document).on('click keydown', '.js-file-trigger, .js-file-label', function (e) {
            if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') return;
            e.preventDefault();
            const pos = $(this).data('position-id');
            if (!pos) return;
            $('#sponsor-file-' + pos).trigger('click');
        });

        $(document).on('change', '.js-sponsor-file-input', (e) => {
            let $input = $(e.currentTarget);
            let pos = $input.data('position-id');
            let file = e.currentTarget.files && e.currentTarget.files[0];
            let $container = $('.file-upload-area-thumbnail[data-position-id="' + pos + '"]');
            let $icon = $container.find('.file-upload-area-thumbnail-icon');
            let $preview = $container.find('.file-upload-preview');
            let $label = $('.js-file-label[data-position-id="' + pos + '"]');
            let $name = $label.find('.js-file-name');
            let $remove = $label.find('.js-file-remove');
			let $adobeIcon =$container.find('.illustrator-icon')
			let $epsIcon = $container.find('.eps-icon')
            if (this.objectUrlMap[pos]) {
                URL.revokeObjectURL(this.objectUrlMap[pos]);
                delete this.objectUrlMap[pos];
            }
            if (file) {
				if (file.type == "application/postscript"){
						let fileName = file.name;
						let lastDotIndex = fileName.lastIndexOf('.')
						let fileExtension = fileName.slice(lastDotIndex);
						if (fileExtension == ".ai"){
							$adobeIcon.removeClass("d-none")
							$epsIcon.addClass("d-none")
							let url = URL.createObjectURL(file);
							this.objectUrlMap[pos] = url;
							$icon.addClass('d-none');
							$name.text(file.name).removeClass('d-none');
							$remove.removeClass('d-none');
							$label.find('.js-file-label-text').addClass('d-none');
							$('#sponsor-' + pos + '-filename').val(file.name);
						} else if ( fileExtension == ".eps") {
							$adobeIcon.addClass("d-none")
							$epsIcon.removeClass("d-none")
							let url = URL.createObjectURL(file);
							this.objectUrlMap[pos] = url;
							$icon.addClass('d-none');
							$name.text(file.name).removeClass('d-none');
							$remove.removeClass('d-none');
							$label.find('.js-file-label-text').addClass('d-none');
							$('#sponsor-' + pos + '-filename').val(file.name);
						};
				} else {
					$adobeIcon.addClass("d-none")
					$epsIcon.addClass("d-none")
					let url = URL.createObjectURL(file);
					this.objectUrlMap[pos] = url;
					$preview.attr('src', url).removeClass('d-none');
					$icon.addClass('d-none');
					$name.text(file.name).removeClass('d-none');
					$remove.removeClass('d-none');
					$label.find('.js-file-label-text').addClass('d-none');
					$('#sponsor-' + pos + '-filename').val(file.name);
				}
            } else {
                $preview.attr('src', '').addClass('d-none');
                $icon.removeClass('d-none');
                $name.text('').addClass('d-none');
                $remove.addClass('d-none');
                $label.find('.js-file-label-text').removeClass('d-none');
                $('#sponsor-' + pos + '-filename').val('');
            }
        });

        $(document).on('click', '.js-file-remove', (e) => {
            e.preventDefault();
			e.stopPropagation();
            let $btn = $(e.currentTarget);
            let $label = $btn.closest('.js-file-label');
            let pos = $label.data('position-id');
            let $input = $('#sponsor-file-' + pos);
            let $container = $('.file-upload-area-thumbnail[data-position-id="' + pos + '"]');
            let $icon = $container.find('.file-upload-area-thumbnail-icon');
            let $preview = $container.find('.file-upload-preview');
			let $adobeIcon =$container.find('.illustrator-icon')
			let $epsIcon = $container.find('.eps-icon')

			$adobeIcon.addClass("d-none")
			$epsIcon.addClass("d-none")

            if (this.objectUrlMap[pos]) {
                URL.revokeObjectURL(this.objectUrlMap[pos]);
                delete this.objectUrlMap[pos];
            }

            const newInput = $('<input>', {
                type: 'file',
                id: $input.attr('id'),
                name: $input.attr('name'),
                accept: $input.attr('accept'),
                'data-position-id': pos,
                class: $input.attr('class')
            });
            $input.replaceWith(newInput);

            $preview.attr('src', '').addClass('d-none');
            $icon.removeClass('d-none');
            $label.find('.js-file-name').text('').addClass('d-none');
            $btn.addClass('d-none');
            $label.find('.js-file-label-text').removeClass('d-none');
            $('#sponsor-' + pos + '-filename').val('');
        });
	}
}

